import { TaskTypes } from 'context';

export type AttendanceType = {
  attendanceId: string;
  /** Backend student id — used to match join-click hints (spec 0013). */
  studentId?: string;
  studentName: string;
  checked?: boolean;
  /**
   * ТЗ 0026: «не отмечен» — отдельное состояние, а не «отсутствовал».
   * `checked` остаётся булевым для чекбокса, но подпись в строке должна их
   * различать: пустой журнал и журнал, где всем проставлено «не был», — это
   * совершенно разные ситуации.
   */
  isUnmarked?: boolean;
  /** 'auto' | 'manual' | '' — кто поставил текущее значение. */
  source?: string;
  /** Время отметки; для auto это время ПЕРВОГО входа. */
  markedAt?: string | null;
  markedByName?: string | null;
};

export type LessonAttachmentType = {
  id: string;
  title: string;
  link: string;
};

export enum AttachmentType {
  student = 'student',
  teacher = 'teacher',
}

export enum HomeworkGradesType {
  DONE = 'DONE',
  CONTAINS_ERRORS = 'CONTAINS_ERRORS',
  NOT_DONE = 'NOT_DONE',
}

export type HomeworksType = {
  studentId: string;
  studentName: string;
  gradeType?: HomeworkGradesType | null;
  mark?: number | null;
};

export type ProgramLessonType = {
  id: string;
  name: string;
  index: number;
  isEnded: boolean;
  isActive?: boolean;
  needToFinish?: boolean | null;
};

export type LessonType = ProgramLessonType & {
  /** Human-readable "day, HH:MM-HH:MM" for display. */
  time: string;
  /** Raw lesson times ("19:00:00"), used to compute the Zoom join window. */
  startTime?: string | null;
  endTime?: string | null;
  date: string;
  finished: boolean;
  lmsDescription: string;
  comment: string;
  video?: string | null;
  taskTypes: string[];
  hasStudentMarks?: boolean | null;
  hasTeacherAttachment?: boolean | null;
  hasStudentAttachment?: boolean | null;
  whiteboardId?: string | null;
  homeworkAssignmentId?: string | null;
  /** rev.3: server gate — homework tab is available on every non-diploma
   * lesson, independent of a teacher-authored assignment. */
  homeworkAvailable?: boolean | null;
  /** spec 0013: the group has a configured join link (URL itself is never
   * exposed in queries — only via the lmsJoinLesson mutation). */
  hasJoinLink?: boolean | null;
  /** spec 0013: a temporary link override is active for today. */
  linkOverrideActive?: boolean | null;
};

export type StudentMarks = {
  mark?: number | null;
  hwMark?: HomeworkGradesType | null;
  date: string;
  taskType: TaskTypes;
};
